module.exports = __webpack_public_path__ + "static/img/huayang@3x.9dda77ab.png";